






























































import { defineComponent } from '@nuxtjs/composition-api';
import CheckoutLayout from '~/modules/checkout/layouts/checkout.vue';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';

export default defineComponent({
  name: 'PropertyList',
  components: {
    CheckoutLayout,
    SkeletonLoader,
  },
});
